<template>
  <div class="overview-page">
    <!-- 頁面標題 -->
    <h1 class="page-title">標籤管理</h1>

    <v-container>
      <!-- 篩選條 -->
      <v-card class="filter-card">
        <v-row class="filter-row" align="center">
          <v-col cols="2.4">
            <div class="answer-input">
              <!-- 名稱輸入框 -->
              <input type="text" id="name-input" v-model="filters.name" placeholder="請輸入名稱"
                class="answer-input-field" />
            </div>
          </v-col>

          <v-col cols="2.4">
            <VueDatePicker v-model="filters.createdAtRange" range locale="Zh" :format="formatRange" placeholder="建立時間範圍"
              type="date" :enable-time="false" :show-action-buttons="false" :week-start="0" class="custom-field"
              teleport="body" @update:modelValue="(value) => handleDateRangeChange('createdAtRange', value)" />
          </v-col>
          <v-col cols="2.4">
            <VueDatePicker v-model="filters.updatedAtRange" range locale="Zh" :format="formatRange" placeholder="異動時間範圍"
              type="date" :enable-time="false" :show-action-buttons="false" :week-start="0" class="custom-field"
              teleport="body" @update:modelValue="(value) => handleDateRangeChange('updatedAtRange', value)" />
          </v-col>
          <v-col cols="2.4">
            <div class="answer-input">
              <!-- 建立人員輸入框 -->
              <input type="text" id="creator-input" v-model="filters.creator" placeholder="請輸入建立人員"
                class="answer-input-field" />
            </div>
          </v-col>

          <v-col cols="2.4">
            <div class="answer-input">
              <!-- 異動人員輸入框 -->
              <input type="text" id="editor-input" v-model="filters.editor" placeholder="請輸入異動人員"
                class="answer-input-field" />
            </div>
          </v-col>

        </v-row>

        <!-- 查詢與清除按鈕 -->
        <v-row class="filter-actions" align="center" justify="end">
          <v-btn outlined color="secondary" @click="clearFilters" class="ml-2">清除</v-btn>
        </v-row>
      </v-card>


      <!-- 資料表 -->
      <v-card class="table-card">
        <!-- 表格上方的操作區 -->
        <div class="table-header-row">
          <v-row align="center" justify="space-between" class="header-options">
            <!-- 每頁顯示筆數選擇器 -->
            <v-col cols="auto">
              <v-row align="center" class="dropdown-wrapper">
                <span class="dropdown-label">每頁顯示:</span>
                <div class="dropdown-container" ref="dropdownRef">
                  <div class="dropdown-selected" @click="toggleDropdown">
                    {{ itemsPerPage }}
                    <span class="dropdown-icon">▼</span>
                  </div>
                  <ul v-if="dropdownOpen" class="dropdown-menu">
                    <li v-for="item in [5, 10, 20, 50]" :key="item" @click="selectItemsPerPage(item)"
                      class="dropdown-item" :class="{ 'active': item === itemsPerPage }">
                      {{ item }}
                    </li>
                  </ul>
                </div>

              </v-row>
            </v-col>

            <!-- 新增標籤按鈕 -->
            <v-col cols="auto">
              <v-btn class="add-tool-btn" color="primary" outlined @click="openAddDialog">
                新增標籤
              </v-btn>
            </v-col>
          </v-row>
        </div>


        <table class="custom-table">
          <!-- 表格欄名 -->
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.value" class="table-header sortable-header"
                @click="sortTable(header.value)">
                {{ header.text }}
                <v-icon small>{{ getSortIcon(header.value) }}</v-icon>
              </th>
              <th class="table-header actions-column">編輯</th>
            </tr>
          </thead>

          <!-- 表格內容 -->
          <tbody>
            <tr v-for="item in paginatedItems" :key="item.Codeno">
              <td class="table-cell">{{ item.Codeno }}</td>
              <td class="table-cell">{{ item.Name }}</td>
              <td class="table-cell">{{ item.createdAt }}</td>
              <td class="table-cell">{{ item.UpdatedAt }}</td>
              <td class="table-cell">{{ item.Creator }}</td>
              <td class="table-cell">{{ item.Editor }}</td>
              <td class="table-cell">{{ item.count }}</td>
              <td class="table-cell actions-cell">
                <!-- <v-icon small class="action-icon" @click="viewItem(item)">mdi-eye</v-icon> -->
                <v-icon small class="action-icon" @click="editItem(item)">mdi-pencil</v-icon>
              </td>
            </tr>
          </tbody>

        </table>
      </v-card>
    </v-container>

    <!-- 新增標籤對話框 -->
    <v-dialog v-model="addDialogVisible" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">新增標籤</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field v-model="newTagName" label="標籤名稱" outlined dense hide-details></v-text-field>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="addTag">確認</v-btn>
          <v-btn color="secondary" text @click="closeAddDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <!-- 檢視框 -->
    <v-dialog v-model="viewDialogVisible" max-width="600px">
      <v-card>
        <!-- 檢視框標題 -->
        <v-card-title class="text-h6 view-dialog-title">
          <v-icon small class="title-icon">mdi-eye</v-icon> 檢視資料
        </v-card-title>
        <v-divider></v-divider>

        <!-- 檢視框內容 -->
        <v-card-text class="view-dialog-content">
          <v-row>

            <v-col cols="6">
              <p><strong>名稱：</strong>{{ selectedItem.Name }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <p><strong>建立時間：</strong>{{ selectedItem.createdAt }}</p>
            </v-col>
            <v-col cols="6">
              <p><strong>異動時間：</strong>{{ selectedItem.UpdatedAt }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <p><strong>建立人員：</strong>{{ selectedItem.Creator }}</p>
            </v-col>
            <v-col cols="6">
              <p><strong>異動人員：</strong>{{ selectedItem.Editor }}</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <!-- 按鈕區 -->
        <v-card-actions class="view-dialog-actions">
          <v-btn color="primary" text @click="closeViewDialog">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- 編輯框 -->
    <v-dialog v-model="editDialogVisible" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">編輯標籤</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field v-model="editItemName" label="名稱" outlined dense hide-details></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="saveEdit">確認</v-btn>
          <v-btn color="secondary" text @click="closeEditDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center" class="pagination-container">
      <!-- 上一頁按鈕 -->
      <button v-if="currentPage > 1" class="arrow-btn" @click="goToPreviousPage">
        <v-icon>mdi-chevron-left</v-icon>
      </button>

      <!-- 動態生成頁碼按鈕 -->
      <button v-for="page in visiblePages" :key="page" class="page-btn" :class="{ 'btn-active': page === currentPage }"
        @click="page !== '...' && goToPage(page)" :disabled="page === '...' || page === currentPage">
        {{ page }}
      </button>

      <!-- 下一頁按鈕 -->
      <button v-if="currentPage < totalPages" class="arrow-btn" @click="goToNextPage">
        <v-icon>mdi-chevron-right</v-icon>
      </button>
    </v-row>


  </div>
</template>


<script>
import axios from "axios";
export default {
  name: "TagManagement",
  data() {
    return {
      headers: [
        { text: "ID", value: "Codeno" },
        { text: "名稱", value: "Name" },
        { text: "建立時間", value: "createdAt" },
        { text: "異動時間", value: "UpdatedAt" },
        { text: "建立人員", value: "Creator" },
        { text: "異動人員", value: "Editor" },
        { text: "使用工具數", value: "count" },
      ],
      filters: {
        name: "",
        creator: "",
        createdAtRange: [], // 建立時間範圍
        updatedAtRange: [], // 異動時間範圍
      },
      items: [
      ],
      sortKey: "",
      sortOrder: "asc", // 排序順序
      viewDialogVisible: false,
      editDialogVisible: false,
      selectedItem: {}, // 被選擇的資料
      editItemName: "",
      addDialogVisible: false, // 控制新增標籤對話框的顯示
      newTagName: "", // 用來存放標籤名稱
      newTagDescription: "", // 用來存放描述
      currentPage: 1, // 當前頁數
      itemsPerPage: 10, // 每頁顯示筆數
      dropdownOpen: false,
    };
  },
  watch: {
    itemsPerPage(newVal) {
      console.log(`每頁顯示筆數已更改為: ${newVal}`);
      this.currentPage = 1; // 重置當前頁為第一頁
    },
    filteredItems() {
      // 如果當前頁超出總頁數，重置到最後一頁
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages || 1;
      }
    },
  },

  computed: {
    visiblePages() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      const pages = [];

      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= 3) {
          pages.push(1, 2, 3, '...', totalPages);
        } else if (currentPage > 3 && currentPage < totalPages - 2) {
          pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
        } else {
          pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
        }
      }

      return pages;
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    }
    ,
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      console.log(`Current Page: ${this.currentPage}, Items:`, this.filteredItems.slice(start, end));
      return this.filteredItems.slice(start, end);
    },
    filteredItems() {
      return this.items.filter((item) => {
        const matchesName =
          !this.filters.name ||
          item.Name.toLowerCase().includes(this.filters.name.toLowerCase());

        const matchesCreator =
          !this.filters.creator ||
          item.Creator.toLowerCase().includes(this.filters.creator.toLowerCase());

        const matchesEditor =
          !this.filters.editor ||
          item.Editor.toLowerCase().includes(this.filters.editor.toLowerCase());

        const matchesCreatedAt =
          !this.filters.createdAtRange.length ||
          (item.createdAt &&
            item.createdAt >= this.formatToDateOnly(this.filters.createdAtRange[0]) &&
            item.createdAt <= this.formatToDateOnly(this.filters.createdAtRange[1]));

        const matchesUpdatedAt =
          !this.filters.updatedAtRange.length ||
          (item.UpdatedAt &&
            item.UpdatedAt >= this.formatToDateOnly(this.filters.updatedAtRange[0]) &&
            item.UpdatedAt <= this.formatToDateOnly(this.filters.updatedAtRange[1]));

        return (
          matchesName &&
          matchesCreator &&
          matchesEditor &&
          matchesCreatedAt &&
          matchesUpdatedAt
        );
      });
    },
  },


  methods: {

    selectPage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page; // 更新當前頁
        this.pageDropdownOpen = false; // 關閉下拉選單
        console.log("Selected Page:", page); // 調試輸出
      } else {
        console.warn("Invalid Page Number:", page);
      }
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen; // 切換選單狀態
    },
    selectItemsPerPage(item) {
      this.itemsPerPage = item; // 更新每頁顯示的筆數
      this.dropdownOpen = false; // 選擇後關閉選單
    },
    handleGlobalClick(event) {
      // 如果點擊的目標不在選單範圍內，則關閉選單
      if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
    watch: {
      itemsPerPage() {
        this.currentPage = 1; // 當切換每頁顯示筆數時，重置到第 1 頁
      },
      filteredItems() {
        // 如果當前頁數超過總頁數時，重置到最後一頁
        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages || 1;
        }
      },
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    parseCustomDate(dateString) {
      if (!dateString) return null;
      const parts = dateString.match(/(\d{4}) 年 (\d{2}) 月 (\d{2}) 日/);
      if (!parts) return null;

      const [, year, month, day] = parts;
      return new Date(`${year}-${month}-${day}`);
    },
    formatToDateOnly(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatRange(range) {
      if (!range || range.length !== 2) return "";
      const [start, end] = range;
      return `${start.toISOString().split("T")[0]} ~ ${end.toISOString().split("T")[0]}`;
    },
    handleDateRangeChange(rangeType, value) {
      if (!value) {
        this.filters[rangeType] = [];
      } else {
        this.filters[rangeType] = value;
      }
    },
    async fetchUseCaseList() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;

        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/UseCaseList`);
        if (response.data.rtnCode === "0000") {
          // 將 API 返回的資料映射到 items，並格式化日期
          this.items = response.data.data.map((item) => ({
            Codeno: item.codeno,
            Name: item.name,
            createdAt: this.formatToDateOnly(this.parseCustomDate(item.createdAt)), // 格式化為 YYYY-MM-DD
            UpdatedAt: this.formatToDateOnly(this.parseCustomDate(item.updatedAt)), // 格式化為 YYYY-MM-DD
            Creator: item.creator,
            Editor: item.editor,
            count: item.count,
          }));
        } else {
          console.error("API 錯誤訊息:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("獲取資料失敗:", error);
      }
    },

    applyFilters() {
      console.log("篩選條件已應用：", this.filters);
    },
    clearFilters() {
      this.filters = {
        name: "",
        creator: "",
        createdAtRange: [],
        updatedAtRange: [],
      };
    },
    sortTable(key) {
      if (this.sortKey === key) {
        // 切換排序順序
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        // 設置新的排序鍵和默認升序
        this.sortKey = key;
        this.sortOrder = "asc";
      }

      // 排序邏輯
      this.items.sort((a, b) => {
        const valueA = a[key];
        const valueB = b[key];

        if (this.sortOrder === "asc") {
          return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
        } else {
          return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
        }
      });
    },

    getSortIcon(key) {
      if (this.sortKey !== key) return "mdi-swap-vertical";
      return this.sortOrder === "asc" ? "mdi-arrow-up" : "mdi-arrow-down";
    },

    viewItem(item) {
      this.selectedItem = item;
      this.viewDialogVisible = true;
    },
    closeViewDialog() {
      this.viewDialogVisible = false;
    },
    editItem(item) {
      this.selectedItem = item;
      this.editItemName = item.Name;
      this.editDialogVisible = true;
    },
    closeEditDialog() {
      this.editDialogVisible = false;
      this.editItemName = "";
    },
    async saveEdit() {
      // 確認已選擇要修改的項目
      if (!this.selectedItem || !this.selectedItem.Codeno) {
        alert("未選擇有效的標籤");
        return;
      }

      if (!this.editItemName.trim()) {
        alert("請輸入有效的名稱！");
        return;
      }

      const baseUrlo = process.env.VUE_APP_SERVICE_URL;
      const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

      try {
        const url = `${baseUrl}/UseCaseEdit/${this.selectedItem.Codeno}`; // API URL
        const payload = {
          name: this.editItemName, // 傳遞新的名稱
        };

        const response = await axios.post(url, payload);

        if (response.data.rtnCode === "0000") {
          alert("修改成功！");
          await this.fetchUseCaseList(); // 重新載入資料
          this.closeEditDialog(); // 關閉對話框
        } else {
          console.error("修改失敗:", response.data.rtnMsg);
          alert(`修改失敗: ${response.data.rtnMsg}`);
        }
      } catch (error) {
        console.error("修改請求失敗:", error);
        alert("修改失敗，請稍後再試！");
      }
    },
    openAddDialog() {
      this.newTagName = ""; // 清空輸入框
      this.addDialogVisible = true; // 打開對話框
    },
    closeAddDialog() {
      this.addDialogVisible = false; // 關閉對話框
    },
    async addTag() {
      if (!this.newTagName.trim()) {
        alert("請輸入標籤名稱！");
        return;
      }

      try {
        // 定義 baseUrlo 和 baseUrl
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

        // 準備 payload 資料
        const payload = {
          name: this.newTagName,
        };

        // 發送 API 請求
        const response = await axios.post(`${baseUrl}/UseCaseEdit`, payload);

        if (response.data.rtnCode === "0000") {
          // 成功新增後，重新載入資料
          await this.fetchUseCaseList(); // 確保表格更新
          this.closeAddDialog();
          alert("新增成功！");
        } else {
          console.error("新增失敗:", response.data.rtnMsg);
          alert(`新增失敗: ${response.data.rtnMsg}`);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
        alert("新增失敗，請稍後再試！");
      }
    }
    ,
  },
  created() {
    this.fetchUseCaseList(); // 組件載入時自動調用 API 獲取資料
    document.addEventListener("click", this.handleGlobalClick); // 添加全局點擊事件
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleGlobalClick); // 移除全局點擊事件
  },
};
</script>


<style scoped>
.answer-input {
  display: flex;
  align-items: center;
  /* 垂直置中 */
  justify-content: center;
  /* 水平置中（視需要） */
  height: 100%;
  /* 確保容器有高度，才會有效果 */
}

.answer-input-field {
  width: 100%;
  height: 42px;
  /* 確保高度一致 */
  padding: 10px 12px;
  /* 與下拉框一致的內邊距 */
  font-size: 14px;
  /* 確保文字大小一致 */
  color: #333;
  /* 字體顏色統一 */
  border: 1px solid #dcdcdc;
  /* 邊框樣式 */
  border-radius: 8px;
  /* 圓角樣式 */
  outline: none;
  background-color: #ffffff;
  transition: border-color 0.2s, background-color 0.2s;
  /* 增加過渡效果 */
  appearance: none;
  /* 去掉瀏覽器預設樣式 */
  -webkit-appearance: none;
  /* Safari 適配 */
}



/* 焦點時的樣式 */
.answer-input-field:focus {
  border-color: #1976d2;
  background-color: #ffffff;
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.2);
}

.answer-input-field::placeholder {
  color: #333;
  /* 統一 placeholder 顏色 */

}

::v-deep(.dp__input) {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  border-radius: 8px; /* 確保與輸入框一致 */
  height: 42px; /* 確保高度一致 */
}

::v-deep(.dp__input::placeholder) {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: normal !important;
  opacity: 1 !important;
  /* 確保不受透明度影響 */
}

/* 下拉選單容器 */
.dropdown-label {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
  /* 左邊增加間距 */
  margin-right: 5px;
  /* 添加適當的間距 */
}

.dropdown-container {
  position: relative;
  display: inline-block;
  width: 100px;
  font-size: 14px;
}

/* 已選中項目 */
.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dropdown-selected:hover {
  border-color: #1976d2;
  background-color: #f9f9f9;
}

/* 下拉箭頭 */
.dropdown-icon {
  font-size: 12px;
  color: #666;
}

/* 下拉選單 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0;
  z-index: 100;
}

/* 下拉選單項目 */
.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #e3f2fd;
}

.dropdown-item.active {
  background-color: #1976d2;
  color: #fff;
}

.add-dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.dialog-actions {
  justify-content: flex-end;
  padding: 16px;
}


/* 檢視框樣式 */
.view-dialog-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  color: #1976d2;
}

.view-dialog-content {
  padding: 16px 20px;
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  background-color: #fafafa;
  border-radius: 8px;
}

.view-dialog-content p {
  margin: 0 0 12px;
}

.view-dialog-actions {
  justify-content: flex-end;
  padding: 16px;
}

/* 整體背景樣式 */
.overview-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

/* 頁面標題樣式 */
.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

/* 篩選條樣式 */
.filter-card {
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
}

.filter-actions {
  margin-top: 10px;
}



/* 表格樣式 */
.table-card {
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
}

.table-header-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.header-options {
  gap: 16px;
  /* 控制下拉選單與按鈕之間的間距 */
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.table-header {
  background-color: #333333;
  color: white;
  font-weight: bold;
  padding: 10px;
  cursor: pointer;
}

.table-cell {
  text-align: center;
  /* 水平置中 */
  vertical-align: middle;
  /* 垂直置中 */
  padding: 8px;
  border-bottom: 1px solid #dcdcdc;
  color: #333333;
}

.actions-cell {
  display: flex;
  gap: 8px;
  justify-content: center;
  /* 水平置中 */
  align-items: center;
  /* 垂直置中 */
}


.action-icon {
  cursor: pointer;
  color: #666666;
}

.action-icon:hover {
  color: #333333;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.current-page-info {
  font-size: 14px;
  font-weight: bold;
}

.items-per-page-select,
.add-tool-btn {
  min-width: 150px;
  /* 確保寬度一致 */
  height: 36px;
  /* 統一高度 */
  font-size: 14px;
  /* 字體大小統一 */
}

.add-tool-btn {
  text-transform: none;
  /* 禁用大寫 */
  padding: 0 16px;
  /* 增加內邊距 */
}

.items-per-page-select .v-input__control {
  padding: 0 16px;
  /* 增加內邊距 */
}

.jump-to-page-select {
  max-width: 120px;
  /* 限制最大寬度 */
  min-width: 100px;
  /* 設置最小寬度，保持一致性 */
  font-size: 14px;
  /* 字體大小 */
}

.jump-to-page-select .v-input__control {
  padding: 0 8px;
  /* 控制內部邊距，讓內容更加緊湊 */
}

.pagination-container {
  display: flex;
  justify-content: center;
  /* 水平置中 */
  align-items: center;
  gap: 10px;
  /* 元素間的間距 */
  padding: 10px 0;
  /* 上下內邊距 */

  /* 背景與表格一致 */
  border-top: 1px solid #dcdcdc;
  /* 分隔線 */
}

.current-page-info {
  font-size: 16px;
  font-weight: bold;
}

.page-select {
  max-width: 120px;
  /* 限制最大寬度 */
  min-width: 100px;
  /* 保證最小寬度一致 */
  font-size: 14px;
  /* 字體大小 */
}

.v-select__control {
  padding: 0 10px;
  /* 控制內部間距 */
  height: 36px;
  /* 確保選框高度統一 */
}

.dropdown-container {
  position: relative;
  display: inline-block;
  width: 120px;
  /* 控制下拉選單寬度 */
  font-size: 14px;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0;
  z-index: 100;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #e3f2fd;
}

.dropdown-item.active {
  background-color: #1976d2;
  color: white;
}

.pagination-container .arrow-btn,
.pagination-container .page-btn {
  background: none;
  /* 移除背景 */
  border: none;
  /* 移除邊框 */
  color: #333;
  /* 按鈕文字顏色 */
  cursor: pointer;
  /* 鼠標樣式 */
  font-size: 14px;
  /* 統一字體大小 */
  padding: 0 8px;
  /* 左右內邊距 */
}

.pagination-container .arrow-btn:hover,
.pagination-container .page-btn:hover {
  color: #1976d2;
  /* 滑鼠懸停時改變顏色 */
}

.pagination-container .page-btn.btn-active {
  color: #1976d2;
  /* 當前頁碼顯示主題色 */
  font-weight: bold;
}
</style>
